"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _classnames = _interopRequireDefault(require("classnames"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _withStyles = _interopRequireDefault(require("../../utils/withStyles"));

var _colors = _interopRequireDefault(require("../../styles/colors"));

var _Loader = _interopRequireDefault(require("../Loader"));

var _styles = _interopRequireDefault(require("./styles"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var Button = function Button(_ref) {
  var classes = _ref.classes,
      children = _ref.children,
      onClick = _ref.onClick,
      disabled = _ref.disabled,
      loading = _ref.loading,
      customLoader = _ref.customLoader,
      backgroundColor = _ref.backgroundColor,
      type = _ref.type,
      isSubmit = _ref.isSubmit,
      props = _objectWithoutProperties(_ref, ["classes", "children", "onClick", "disabled", "loading", "customLoader", "backgroundColor", "type", "isSubmit"]);

  return _react["default"].createElement("button", _extends({
    type: isSubmit ? 'submit' : 'button',
    className: (0, _classnames["default"])(classes.root, disabled || loading ? classes.disabled : null),
    onClick: onClick,
    disabled: disabled || loading
  }, props), loading && _react["default"].createElement("div", {
    className: classes.loaderContainer
  }, customLoader || _react["default"].createElement(_Loader["default"], {
    scale: 0.5,
    color: _colors["default"].ash
  })), _react["default"].createElement("div", {
    className: classes.childrenContainer
  }, children));
};

Button.propTypes = {
  /** Map of rule names and generated class names */
  classes: _propTypes["default"].objectOf(_propTypes["default"].string).isRequired,

  /** Children of Button component */
  children: _propTypes["default"].node,

  /** Button can be of 3 types - 'default', 'cancel', 'warning' */
  type: _propTypes["default"].oneOf(['default', 'cancel', 'warning']),

  /** Button onClick callback */
  onClick: _propTypes["default"].func,

  /** Bool flag to enable/disable the button */
  disabled: _propTypes["default"].bool,

  /** A loading button is auto-disabled and displays a spinning loader */
  loading: _propTypes["default"].bool,

  /** Provide a customized loader element if necessary */
  customLoader: _propTypes["default"].element,

  /**
   * If true, the button will be of `type` "submit" instead of `type` "button", `type` here referring to the HTML property.
   * Clicking a button of type "submit" will trigger the onSubmit event of its closest <form> ancestor.
   *
   * @deprecated
   * Triggering a submit handler directly on button click is the preferred method. This property will be removed in v3.
   */
  isSubmit: _propTypes["default"].bool
};
Button.defaultProps = {
  children: null,
  type: 'default',
  onClick: function onClick() {},
  disabled: false,
  loading: false,
  customLoader: null,
  isSubmit: false
};

var _default = (0, _withStyles["default"])(_styles["default"])(Button);

exports["default"] = _default;